module.exports = __webpack_public_path__ + "static/media/vil_logo.13f3aa42.svg";